import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ExTable,
    FixedFooter,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useCancelTaskApi, useCompleteTaskApi, useFetchTasksApi } from 'api/task'
import { MaterialTaskData, Task, TaskSearchForm } from 'entities/task'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { taskColumnInfoList, TaskTableData } from './task_table'
import { DisplaySetting, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { Flex } from 'components/shared/flex'
import { Badge, Button } from 'react-bootstrap'
import moment from 'moment'
import { InstitutionSearchForm } from 'entities/institution'

type Props = {
    history: H.History
}

const TasksPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<TaskSearchForm>()
    const searchForm = useForm<TaskSearchForm>(query)
    const api = useFetchTasksApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<Task>()
    const taskDisplaySetting = useDisplaySetting(taskColumnInfoList(searchForm, query.kind), 'Task')
    const displaySettings: DisplaySetting[] = [taskDisplaySetting]
    const [selectedTask, setSelectedTask] = useState<Task>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const completeApi = useCompleteTaskApi()
    const cancelApi = useCancelTaskApi()
    const [tasks, setTasks] = useState<Task[]>([])
    const institutionSearchForm = useForm<InstitutionSearchForm>({})

    useEffect(() => {
        api.execute()
    }, [])

    useEffectSkipFirst(() => {
        if (api.isSuccess()) {
            setTasks(api.response.results)
        }
    }, [api.loading])

    const handleClickRemoveFilter = (key: keyof TaskSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`tasks?${queryParams}`)
        }
    }, [searchForm.object])

    useEffectSkipFirst(() => {
        globalState.setLoading(completeApi.loading)
    }, [completeApi.loading])

    return (
        <>
            {/* <EditTaskForm
                task={selectedTask}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            /> */}
            <ContentHeader
                headerTitle="タスク一覧"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        {/* <NewTaskForm
                            onComplete={() => {
                                api.execute()
                            }}
                        /> */}
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    // <DisplaySettingModal displaySettings={displaySettings} />
                    <Flex></Flex>
                }
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter contentHeaderCount={1}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <TableRow>
                                <TableHeads displaySetting={taskDisplaySetting} />
                                <TableCell th width={80}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={taskDisplaySetting.getColumnLength() + 1}>
                            {tasks.map((task: Task) => {
                                return (
                                    <TableRow
                                        key={`task-${task.id}`}
                                        style={{
                                            backgroundColor: task.completedAt ? '#eee' : '#fff',
                                        }}
                                    >
                                        <TaskTableData task={task} displaySetting={taskDisplaySetting} />
                                        <TableCell align="center">
                                            {!task.completedAt ? (
                                                <Button
                                                    size="sm"
                                                    variant="success"
                                                    onClick={() => {
                                                        task.completedAt = moment().format('YYYY-MM-DD HH:mm:ss')
                                                        task.completeUser = globalState.user
                                                        completeApi.execute(task.id!)
                                                        setTasks(tasks)
                                                    }}
                                                >
                                                    完了
                                                </Button>
                                            ) : (
                                                <Button
                                                    size="sm"
                                                    variant="danger"
                                                    onClick={() => {
                                                        globalState.showConfirm('取り消しますか？', () => {
                                                            task.completedAt = undefined
                                                            task.completeUser = undefined
                                                            cancelApi.execute(task.id!)
                                                            setTasks(tasks)
                                                        })
                                                    }}
                                                >
                                                    取消
                                                </Button>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            {/* <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Task"
            ></SelectionFixedFooter> */}
            {query.kind === 'MATERIAL' && (
                <FixedFooter open>
                    <div style={{ fontSize: 14 }}>用意するもの: </div>
                    <Flex flexWrap="wrap">
                        {(() => {
                            const result: Record<string, number> = {}
                            tasks.forEach((task) => {
                                const data: MaterialTaskData = JSON.parse(task.data || '{}')
                                result[data.material_name!] ? (result[data.material_name!] += data.number!) : (result[data.material_name!] = data.number!)
                            })
                            return Object.keys(result).map((materialName, index) => {
                                return (
                                    <div key={'aggregation-' + index}>
                                        <Badge>
                                            {materialName}: {result[materialName]}部
                                        </Badge>
                                    </div>
                                )
                            })
                        })()}
                    </Flex>
                </FixedFooter>
            )}
        </>
    )
}

export default withRouter(TasksPage)
